import React, { useEffect, useMemo } from 'react';
import { PageWithNavigation } from '@/src/components';

import { Stack, Margin } from '@ovotech/element-v5';

import { Hero } from './components/Hero';
import { Rtbs } from './components/Rtbs';
import { NearlyThere } from './components/NearlyThere';
import { DirectDebit } from './components/DirectDebit';
import { SmartMeter } from './components/SmartMeter';
import { GetApp } from './components/GetApp';
import { useBeyondAccountFlags } from '@/src/hooks/useBeyondAccountFlags/useBeyondAccountFlags';
import { useDecision } from '@/src/utils/optimizely';
import { BEYOND_WEB_PRESENCE } from '@/src/constants/feature-flags';
import { useAnalytics } from '@ovotech/ui-tools';
import { ALL_REWARDS_PAGE } from '@/src/constants/analytics';

export const AllRewards = () => {
  const {
    isIneligible,
    hasSmartMeter,
    hasDirectDebit,
    isFetched,
    beyondStatus,
  } = useBeyondAccountFlags();
  const [beyondWebPresence] = useDecision(BEYOND_WEB_PRESENCE) || [
    { variationKey: null, enabled: false },
  ];
  const { dispatch } = useAnalytics();

  const analyticsProps = useMemo(
    () => ({
      ...(beyondStatus && { 'Beyond Status': beyondStatus }),
      ...(beyondWebPresence.enabled && {
        'Test variant':
          beyondWebPresence.variationKey === 'rewards' ? 'Rewards' : 'Beyond',
      }),
    }),
    [beyondWebPresence, beyondStatus],
  );

  useEffect(() => {
    if (isFetched) {
      dispatch({
        name: 'All Rewards',
        type: 'page',
        properties: analyticsProps,
      });
    }
    // we only want to call dispatch once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched]);

  const onAppStoreClicked = () =>
    dispatch({
      name: ALL_REWARDS_PAGE.GET_APP.CLICKED_APP_STORE,
      type: 'click',
      properties: analyticsProps,
    });

  const onGooglePlayClicked = () =>
    dispatch({
      name: ALL_REWARDS_PAGE.GET_APP.CLICKED_GOOGLE_PLAY,
      type: 'click',
      properties: analyticsProps,
    });

  return (
    <PageWithNavigation title="All rewards">
      <Margin top={8}>
        <Stack spaceBetween={5}>
          <Hero />
          <Rtbs />
          <NearlyThere />
          {(!hasDirectDebit || isIneligible) && (
            <DirectDebit analyticsProps={analyticsProps} />
          )}
          {(!hasSmartMeter || isIneligible) && (
            <SmartMeter analyticsProps={analyticsProps} />
          )}
          <GetApp
            onAppStoreClick={onAppStoreClicked}
            onGooglePlayClick={onGooglePlayClicked}
          />
        </Stack>
      </Margin>
    </PageWithNavigation>
  );
};
